// Shell URLs use Storybook's shape, so links and bookmarks survive a move:
//   ?path=/docs/forms-toggle--docs
//   ?path=/story/forms-toggle--playground&globals=theme:dark&args={"label":"Hi"}
//   ?path=/compose                       (the Compose page, edl-docs' own)

export function readUrl() {
  const params = new URLSearchParams(location.search);
  const path = params.get('path') ?? '';
  const m = path.match(/^\/(docs|story)\/([^/?#]+)/);
  const globals = {};
  for (const pair of (params.get('globals') ?? '').split(';').filter(Boolean)) {
    const [k, ...rest] = pair.split(':');
    globals[k] = decodeURIComponent(rest.join(':'));
  }
  let args = null;
  try {
    args = params.get('args') ? JSON.parse(params.get('args')) : null;
  } catch {}
  const viewportParam = params.get('viewport');
  const viewport = viewportParam && /^\d+$/.test(viewportParam) ? Number(viewportParam) : null;
  return {
    id: m ? m[2] : null,
    viewMode: m ? m[1] : null,
    page: path === '/compose' ? 'compose' : null,
    globals,
    args,
    viewport,
    hasViewport: viewportParam != null,
    hash: decodeURIComponent(location.hash.slice(1)),
  };
}

export function writeUrl({ id, viewMode, page, globals, args, viewport, hash = '' }, { replace = false, state } = {}) {
  const params = new URLSearchParams();
  if (id) params.set('path', `/${viewMode ?? (id.endsWith('--docs') ? 'docs' : 'story')}/${id}`);
  else if (page) params.set('path', `/${page}`);
  const g = Object.entries(globals ?? {}).filter(([, v]) => v != null);
  if (g.length) params.set('globals', g.map(([k, v]) => `${k}:${v}`).join(';'));
  if (args && Object.keys(args).length) params.set('args', JSON.stringify(args));
  if (viewMode === 'story' && Number.isFinite(viewport) && viewport > 0) params.set('viewport', String(Math.round(viewport)));
  const search = params.toString().replace(/%2F/g, '/').replace(/%3A/g, ':').replace(/%3B/g, ';');
  const url = `${location.pathname}${search ? '?' + search : ''}${hash ? `#${encodeURIComponent(hash)}` : ''}`;
  if (url === `${location.pathname}${location.search}${location.hash}`) return;
  history[replace ? 'replaceState' : 'pushState'](state === undefined ? (replace ? history.state : null) : state, '', url);
}
